"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeelchairFriendly;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function WeelchairFriendly(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "weelchair-friendly"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.474,72.435a2.5,2.5,0,0,0-3.223,1.455,21.052,21.052,0,0,1-40.745-7.439,20.93,20.93,0,0,1,11.768-18.9,2.5,2.5,0,1,0-2.207-4.487A26.053,26.053,0,0,0,39.555,92.5,26.187,26.187,0,0,0,63.929,75.657,2.5,2.5,0,0,0,62.474,72.435Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.353,75.772a2.5,2.5,0,0,0-3.189-1.528l-8.809,3.1L63.869,54.054A2.5,2.5,0,0,0,61.59,52.58H38.143l-.386-5.992H56.872a2.5,2.5,0,0,0,0-5H37.436L36.4,25.451c.034,0,.067,0,.1,0a7.748,7.748,0,1,0-5.244-2.063l1.3,20.174a2.364,2.364,0,0,0,.084,1.313L33.3,55.24a2.5,2.5,0,0,0,2.5,2.34H59.974L70.739,81.494a2.5,2.5,0,0,0,3.11,1.332l10.975-3.865A2.5,2.5,0,0,0,86.353,75.772Z"
  })))));
}